import React from 'react';
import Image from 'react-bootstrap/Image';

import useGetLabels from '../../../../Hook/Interest/UseGetLabels';

interface Props {
    finDataCode: string;
}

const CompanyIcon: React.FC<Props> = ({ finDataCode }: Props) => {
    const { allLabels } = useGetLabels(true);

    const label = allLabels.find(currentLabel => currentLabel.findataCode === finDataCode);

    if (label === undefined) return null;

    return (
        <span>
            <Image src={label.iconUrl} className="company-icon" />
        </span>
    );
};

export default CompanyIcon;
